export const ROLES = {
  ADMIN: '1',
  VENDOR: '2',
  MEMBER_COMMITTEE: '3',
  CHIEF_ENGINEER: '4',
  ASH_HANDLING_OFFICER: '5',
  INSPECTION: '8',
} as const;

export const ROLE_NAMES = {
  ASH_HANDLING: 'Ash Handling',
  INSPECTION: 'Inspection',
} as const;

export type RoleId = (typeof ROLES)[keyof typeof ROLES];
